export default __webpack_public_path__ + "static/media/Saghfi.6121a269.png";